var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiProtocol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4268 14.2562L8.93364 15.3876C8.57274 16.2158 7.42714 16.2158 7.06624 15.3876L6.57312 14.2562C5.69412 12.2389 4.1109 10.6328 2.13534 9.75416L0.616094 9.07844C-0.205364 8.71306 -0.205364 7.51762 0.616094 7.15224L2.0504 6.51428C4.07676 5.61302 5.68834 3.94746 6.55224 1.86166L7.05864 0.639068C7.41156 -0.213022 8.58834 -0.213022 8.94126 0.639068L9.44764 1.86166C10.3115 3.94746 11.9232 5.61302 13.9496 6.51428L15.3838 7.15224C16.2054 7.51762 16.2054 8.71306 15.3838 9.07844L13.8646 9.75416C11.889 10.6328 10.3058 12.2389 9.4268 14.2562ZM12.6684 31.6308C13.0206 30.466 13.4144 29.3124 13.8782 28.0654C17.9897 17.0127 24.8394 10.1634 36.0258 8.42958C35 10.7168 34.0302 12.306 33.1716 13.1647C32.5042 13.8321 31.837 14.4999 31.1696 15.1681L28.3442 17.9976L31.2558 20.907C28.9952 25.0768 24.5304 28.3958 19.5039 29.024C16.8709 29.3532 14.5869 30.2376 12.6684 31.6308ZM36 19.9932L34 17.9946C34.6662 17.3274 35.3324 16.6608 36.0054 15.9878C38.0036 13.9861 40.0018 9.98784 42 3.99316C12.6221 3.99316 8.17708 30.844 6.12722 43.2264C6.0838 43.4886 6.04148 43.7444 6 43.9932H9.99648C11.3284 37.327 14.6629 33.6602 20 32.9932C28 31.9932 34 25.9932 36 19.9932Z",
    fill: "url(#paint0_linear_25519_1485)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25519_1485",
    x1: 0,
    y1: 0,
    x2: 22.6013,
    y2: 43.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiProtocol);
export default __webpack_public_path__ + "static/media/ai-protocol.8fe1d2136cb1fbccbaf7164d1bd3fd1b.svg";
export { ForwardRef as ReactComponent };